<template>
  <div class="filter__categories">
    <multiselect
      v-model="value"
      :options="options"
      :multiple="true"
      :searchable="false"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      :preselect-first="false"
      open-direction="bottom"
      :max="9"
      placeholder="Filtrer par secteur d'activité"
      label="name"
      track-by="name"
      @input="update"
    >
    </multiselect>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);

export default {
  data() {
    return {
      value: [],
      options: [],
    };
  },
  methods: {
    update() {
      this.$store.dispatch("filterEntreprisesByCategories", this.value);
    },
    putSelectedFirst() {
      this.options.forEach((option) => {
        const index = this.options.indexOf(option);
        const elements = document.querySelectorAll(".multiselect__element");
        if (
          this.value.includes(this.value.find((v) => v.name === option.name))
        ) {
          elements[index].style.order = 0;
        } else {
          elements[index].style.order = 1;
        }
      });
    },
  },
  computed: {
    categories() {
      return this.$store.getters.categories;
    },
  },

  mounted() {
    this.options = this.categories;
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.filter__categories {
  // margin-bottom: 10px;
  &::v-deep {
    .multiselect {
      position: relative;
      color: var(--black);
      cursor: pointer;
      &--active {
        .multiselect__single {
          border: 1px solid var(--green);
          border-radius: 5px 5px 0 0;
        }
      }
      &::after {
        z-index: 9999;
        content: "";
        position: absolute;
        bottom: 21px;
        right: 20px;
        width: 10px;
        height: 10px;
        background-image: url("../assets/images/icons/icon-chevron.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 10px auto;
        pointer-events: none;
      }
      &__select {
        display: none;
        // z-index: 9999;
      }
      &__tags {
        padding: 0;
        border: none;
        display: flex;
        flex-direction: column;
      }
      &__tag {
        background: var(--lightGray);
        color: var(--black);
        max-width: calc(100% / 3 - 10px);
        overflow: hidden;
        border-radius: 50px;
        margin: 0;
        padding: 5px 20px 5px 10px;
        font-size: 11px;
        user-select: none;
        // display: none;
        &-icon {
          width: 20px;
          margin: 0;
          background: transparent;
          &:hover {
            &:after {
              color: var(--black);
            }
          }
          &::after {
            font-size: 15px;
            color: rgb(93, 93, 93);
            font-weight: 700;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      &__tags-wrap {
        // display: none !important;
        // order: 2;
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
      }
      &__input,
      &__single {
        order: 1;
        display: flex;
        z-index: 999;
        width: 100% !important;
        position: relative !important;
        padding: 15px 20px;
        padding-left: 50px;
        margin: 0;
        // margin-bottom: 10px;
        color: rgba(29, 29, 27, 0.5);
        border: 1px solid var(--lightGray);
        background-image: url("../assets/images/icons/icon-options.svg");
        background-repeat: no-repeat;
        background-position: 20px center;
        background-size: 15px auto;
        // &::placeholder {
        //   color: var(--black);
        //   opacity: 0.5;
        // }
        // &:focus {
        //   border: 1px solid var(--green);
        // }
      }
      &__content-wrapper {
        max-height: 350px !important;
        overflow-x: hidden;
        border: none;
        box-shadow: 0 0px 35px 0px rgba(0, 0, 0, 0.3);
      }
      &__content {
        display: flex !important;
        flex-direction: column;
      }
      &__element {
        // width: 100%;
        // display: flex;
        // &:first-child {
        //   order: 10;
        // }
        order: 1;
        &:not(:nth-last-child(2)) {
          border-bottom: 1px solid var(--gray);
        }
      }
      &__option {
        padding: 20px 20px;
        white-space: normal;
        &--highlight {
          background: rgb(250, 250, 250);
          color: var(--green);
        }
        &--selected {
          background: var(--green);
          color: var(--white);
        }
        &::after {
          display: none;
        }
      }
    }
    .multiselect__tags-wrap {
      margin-top: 10px;
      gap: 10px;
      .multiselect__tag {
        padding: 10px 15px;
        color: var(--black);
        background-color: var(--lightGray);
        i {
          &::after {
            content: "";
            width: 10px;
            height: 10px;
            background-image: url("../assets/images/icons/icon-close.svg");
            background-repeat: no-repeat;
            background-position: center;
            background-size: contain;
          }
        }
      }
    }
  }
}
</style>
